import { render, staticRenderFns } from "./DataSat.vue?vue&type=template&id=6205e575&scoped=true&"
import script from "./DataSat.vue?vue&type=script&lang=js&"
export * from "./DataSat.vue?vue&type=script&lang=js&"
import style0 from "./DataSat.vue?vue&type=style&index=0&id=6205e575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6205e575",
  null
  
)

export default component.exports